import { render, staticRenderFns } from "./_ActiveCompanies.vue?vue&type=template&id=5d998942&"
import script from "./_ActiveCompanies.vue?vue&type=script&lang=ts&"
export * from "./_ActiveCompanies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports